import React, { useEffect } from "react";
import { MapContainer, TileLayer, useMap, Marker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet.heat";

const HeatLayer = ({ data }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const heatLayer = L.heatLayer(data, {
      radius: 20,  // Tamanho do calor
      blur: 10,    // Suavização
      maxZoom: 5,
      max: 1,    // Intensidade máxima do calor
    }).addTo(map);

    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, data]);

  return null;
};

const HeatMapBrazil = ({ data, markers }) => {
  return (
    <MapContainer
      center={[-14.235, -51.9253]} // Centro do Brasil
      zoom={4.4} // Nível de zoom inicial
      style={{ height: "75vh", width: "30vw" }}
    >
      {/* Mapa base OpenStreetMap */}
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      
      {/* Camada de calor */}
      <HeatLayer data={data} />

      {/* Adiciona marcadores com tooltip */}
      {markers.map(({ lat, lon, city, restaurants }, index) => (
        <Marker key={index} position={[lat, lon]} opacity={0}>
          <Tooltip direction="top" offset={[0, -10]} permanent={false}>
            <b>{city}</b>
            <ul>
              {restaurants.map((r, i) => (
                <li key={i}>{r.fantasy_name}</li>
              ))}
            </ul>
          </Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default HeatMapBrazil;
